// extracted by mini-css-extract-plugin
export var popup_deadlines_desktop = "styles-module--popup_deadlines_desktop--ba74a";
export var popup_deadlines_mobile = "styles-module--popup_deadlines_mobile--ef03c";
export var popup_title_deadline = "styles-module--popup_title_deadline--264ae";
export var popup_title_deadline_c = "styles-module--popup_title_deadline_c--21a91";
export var popup_title_shipping_date = "styles-module--popup_title_shipping_date--1dfc2";